module.exports = __webpack_public_path__ + "static/media/TN-Men-Knit.1db5685d.svg";